var __getOwnPropNames = Object.getOwnPropertyNames;
var __esm = (fn, res) => function __init() {
  return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
};

// ../one-ricos/dist/es/_shared/theme-color-token.js
function isThemeColorToken(value) {
  return !!parseThemeColorToken(value);
}
function stripThemeColorTokenOpacity(token) {
  return parseThemeColorToken(token)?.baseToken ?? token;
}
function getThemeColorTokenOpacity(token) {
  return parseThemeColorToken(token)?.opacity ?? 100;
}
function setThemeColorTokenOpacity(token, opacity) {
  const parsed = parseThemeColorToken(token);
  if (!parsed) {
    return token;
  }
  const normalizedOpacity = Math.max(0, Math.min(100, Math.round(opacity)));
  return normalizedOpacity === 100 ? parsed.baseToken : `${parsed.baseToken}-${normalizedOpacity}`;
}
function themeColorTokenToCssVar(token, format) {
  const baseToken = stripThemeColorTokenOpacity(token);
  const varName = `--ricos-${baseToken.slice(1)}`;
  return format === "rgbTuple" ? `var(${varName}-tuple)` : `var(${varName})`;
}
function parseThemeColorToken(value) {
  if (typeof value !== "string") {
    return void 0;
  }
  const match = value.match(THEME_COLOR_TOKEN_REGEXP);
  if (!match) {
    return void 0;
  }
  const slot = match[1];
  const opacity = match[2] ? Number(match[2]) : 100;
  return {
    slot,
    opacity,
    baseToken: `$theme-color-${slot}`
  };
}
var THEME_COLOR_TOKEN_REGEXP;
var init_theme_color_token = __esm({
  "../one-ricos/dist/es/_shared/theme-color-token.js"() {
    "use strict";
    THEME_COLOR_TOKEN_REGEXP = /^\$theme-color-([1-9])(?:-(100|[1-9]\d|[0-9]))?$/;
  }
});

// ../one-ricos/dist/es/wix-rich-content-common/Utils/color-utils.js
var isHexColor, combineHexWithOpacity, getOpacityFromHex, getHexColorFromAlpha;
var init_color_utils = __esm({
  "../one-ricos/dist/es/wix-rich-content-common/Utils/color-utils.js"() {
    "use strict";
    init_theme_color_token();
    isHexColor = (str) => /^#(?:[0-9a-f]{3}|[0-9a-f]{4}|[0-9a-f]{6}|[0-9a-f]{8})$/i.test(str);
    combineHexWithOpacity = (hexColor, opacityPercentage) => {
      if (!hexColor) {
        return;
      }
      if (isThemeColorToken(hexColor)) {
        return setThemeColorTokenOpacity(hexColor, opacityPercentage);
      }
      if (opacityPercentage === 100) {
        return hexColor.slice(0, 7);
      }
      const alpha = Math.round(opacityPercentage / 100 * 255);
      const alphaHex = alpha.toString(16).padStart(2, "0").toUpperCase();
      return `${hexColor.slice(0, 7)}${alphaHex}`;
    };
    getOpacityFromHex = (hexColorWithAlpha) => {
      if (isThemeColorToken(hexColorWithAlpha)) {
        return getThemeColorTokenOpacity(hexColorWithAlpha);
      }
      if (!hexColorWithAlpha || hexColorWithAlpha.length === 7 || !isHexColor(hexColorWithAlpha)) {
        return 100;
      }
      const hex = hexColorWithAlpha.replace("#", "");
      const alphaHex = hex.slice(6, 8);
      const alphaDecimal = parseInt(alphaHex, 16);
      return Math.round(alphaDecimal / 255 * 100);
    };
    getHexColorFromAlpha = (hexColorWithAlpha) => {
      if (isThemeColorToken(hexColorWithAlpha)) {
        return stripThemeColorTokenOpacity(hexColorWithAlpha);
      }
      if (!hexColorWithAlpha || hexColorWithAlpha.length === 7 || !isHexColor(hexColorWithAlpha)) {
        return hexColorWithAlpha;
      }
      return hexColorWithAlpha.slice(0, 7);
    };
  }
});

// ../one-ricos/dist/es/theme-utils/color-utils.js
var SHADES_RATIOS, HEX_COLOR_RE, parseHexToRgb, rgbToHexString, clampChannel, mixChannels, calculateShades, hexToRgba, getOpacityFromHex2, getHexColorFromAlpha2;
var init_color_utils2 = __esm({
  "../one-ricos/dist/es/theme-utils/color-utils.js"() {
    "use strict";
    init_theme_color_token();
    SHADES_RATIOS = { shade1: 0.1, shade2: 0.3, shade3: 0.5 };
    HEX_COLOR_RE = /^#?([0-9a-fA-F]{6})$/;
    parseHexToRgb = (hex) => {
      const match = hex.match(HEX_COLOR_RE);
      if (!match) {
        return { r: 0, g: 0, b: 0 };
      }
      const h = match[1];
      return {
        r: parseInt(h.substring(0, 2), 16),
        g: parseInt(h.substring(2, 4), 16),
        b: parseInt(h.substring(4, 6), 16)
      };
    };
    rgbToHexString = ({ r, g, b }) => {
      const toHex = (v) => Math.round(v).toString(16).padStart(2, "0");
      return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
    };
    clampChannel = (v) => Math.round(Math.min(255, Math.max(0, v)));
    mixChannels = (dark, light, darkRatio) => ({
      r: clampChannel(darkRatio * dark.r + (1 - darkRatio) * light.r),
      g: clampChannel(darkRatio * dark.g + (1 - darkRatio) * light.g),
      b: clampChannel(darkRatio * dark.b + (1 - darkRatio) * light.b)
    });
    calculateShades = (lightHex, darkHex) => {
      const light = parseHexToRgb(lightHex);
      const dark = parseHexToRgb(darkHex);
      return [
        rgbToHexString(mixChannels(dark, light, SHADES_RATIOS.shade1)),
        rgbToHexString(mixChannels(dark, light, SHADES_RATIOS.shade2)),
        rgbToHexString(mixChannels(dark, light, SHADES_RATIOS.shade3))
      ];
    };
    hexToRgba = (alphaHex, opacity) => {
      if (!alphaHex) {
        return "";
      }
      if (isThemeColorToken(alphaHex)) {
        const effectiveOpacity = opacity ?? getThemeColorTokenOpacity(alphaHex);
        if (effectiveOpacity < 100) {
          const tupleVar = themeColorTokenToCssVar(alphaHex, "rgbTuple");
          return `rgba(${tupleVar}, ${effectiveOpacity / 100})`;
        }
        return themeColorTokenToCssVar(alphaHex);
      }
      const opacityPercentage = opacity ?? getOpacityFromHex2(alphaHex);
      let hexColor = getHexColorFromAlpha2(alphaHex)?.replace(/^#/, "") ?? "";
      if (hexColor.length === 3) {
        hexColor = hexColor.split("").map((char) => char + char).join("");
      }
      const bigint = parseInt(hexColor, 16);
      const r = bigint >> 16 & 255;
      const g = bigint >> 8 & 255;
      const b = bigint & 255;
      return `rgba(${r}, ${g}, ${b}${opacityPercentage !== void 0 ? `, ${opacityPercentage / 100}` : ""})`;
    };
    getOpacityFromHex2 = (hexColorWithAlpha) => {
      if (isThemeColorToken(hexColorWithAlpha)) {
        return getThemeColorTokenOpacity(hexColorWithAlpha);
      }
      if (!hexColorWithAlpha || hexColorWithAlpha.length === 7) {
        return 100;
      }
      const hex = hexColorWithAlpha.replace("#", "");
      const alphaHex = hex.slice(6, 8);
      const alphaDecimal = parseInt(alphaHex, 16);
      return Math.round(alphaDecimal / 255 * 100);
    };
    getHexColorFromAlpha2 = (hexColorWithAlpha) => {
      if (isThemeColorToken(hexColorWithAlpha)) {
        return stripThemeColorTokenOpacity(hexColorWithAlpha);
      }
      if (!hexColorWithAlpha || hexColorWithAlpha.length === 7) {
        return hexColorWithAlpha;
      }
      return hexColorWithAlpha.slice(0, 7);
    };
  }
});

// ../one-ricos/dist/es/_shared/resolve-backward-compat-overlay.js
init_color_utils();
function resolveBackwardCompatOverlay(color, imageOpacity, opacityMax) {
  const inverted = (opacityMax - imageOpacity) / opacityMax;
  const baked = getOpacityFromHex(color) / 100;
  return combineHexWithOpacity(getHexColorFromAlpha(color), inverted * baked * 100) ?? color;
}

// ../one-ricos/dist/es/theme-utils/index.js
init_color_utils2();

// ../../node_modules/@wix/ambassador-ricos-v1-ricos-conversation/es/build/types.impl.js
var NodeType;
(function(NodeType2) {
  NodeType2["PARAGRAPH"] = "PARAGRAPH";
  NodeType2["TEXT"] = "TEXT";
  NodeType2["HEADING"] = "HEADING";
  NodeType2["BULLETED_LIST"] = "BULLETED_LIST";
  NodeType2["ORDERED_LIST"] = "ORDERED_LIST";
  NodeType2["LIST_ITEM"] = "LIST_ITEM";
  NodeType2["BLOCKQUOTE"] = "BLOCKQUOTE";
  NodeType2["CODE_BLOCK"] = "CODE_BLOCK";
  NodeType2["VIDEO"] = "VIDEO";
  NodeType2["DIVIDER"] = "DIVIDER";
  NodeType2["FILE"] = "FILE";
  NodeType2["GALLERY"] = "GALLERY";
  NodeType2["GIF"] = "GIF";
  NodeType2["HTML"] = "HTML";
  NodeType2["IMAGE"] = "IMAGE";
  NodeType2["LINK_PREVIEW"] = "LINK_PREVIEW";
  NodeType2["MAP"] = "MAP";
  NodeType2["POLL"] = "POLL";
  NodeType2["APP_EMBED"] = "APP_EMBED";
  NodeType2["BUTTON"] = "BUTTON";
  NodeType2["COLLAPSIBLE_LIST"] = "COLLAPSIBLE_LIST";
  NodeType2["TABLE"] = "TABLE";
  NodeType2["EMBED"] = "EMBED";
  NodeType2["COLLAPSIBLE_ITEM"] = "COLLAPSIBLE_ITEM";
  NodeType2["COLLAPSIBLE_ITEM_TITLE"] = "COLLAPSIBLE_ITEM_TITLE";
  NodeType2["COLLAPSIBLE_ITEM_BODY"] = "COLLAPSIBLE_ITEM_BODY";
  NodeType2["TABLE_CELL"] = "TABLE_CELL";
  NodeType2["TABLE_ROW"] = "TABLE_ROW";
  NodeType2["EXTERNAL"] = "EXTERNAL";
  NodeType2["AUDIO"] = "AUDIO";
  NodeType2["CAPTION"] = "CAPTION";
  NodeType2["LAYOUT"] = "LAYOUT";
  NodeType2["LAYOUT_CELL"] = "LAYOUT_CELL";
  NodeType2["SHAPE"] = "SHAPE";
  NodeType2["CARD"] = "CARD";
  NodeType2["TOC"] = "TOC";
})(NodeType || (NodeType = {}));
var StylesBackgroundType;
(function(StylesBackgroundType2) {
  StylesBackgroundType2["COLOR"] = "COLOR";
  StylesBackgroundType2["GRADIENT"] = "GRADIENT";
})(StylesBackgroundType || (StylesBackgroundType = {}));
var V1GradientType;
(function(V1GradientType2) {
  V1GradientType2["LINEAR"] = "LINEAR";
  V1GradientType2["RADIAL"] = "RADIAL";
})(V1GradientType || (V1GradientType = {}));
var WidthType;
(function(WidthType2) {
  WidthType2["CONTENT"] = "CONTENT";
  WidthType2["SMALL"] = "SMALL";
  WidthType2["ORIGINAL"] = "ORIGINAL";
  WidthType2["FULL_WIDTH"] = "FULL_WIDTH";
})(WidthType || (WidthType = {}));
var PluginContainerDataAlignment;
(function(PluginContainerDataAlignment2) {
  PluginContainerDataAlignment2["CENTER"] = "CENTER";
  PluginContainerDataAlignment2["LEFT"] = "LEFT";
  PluginContainerDataAlignment2["RIGHT"] = "RIGHT";
})(PluginContainerDataAlignment || (PluginContainerDataAlignment = {}));
var Type;
(function(Type2) {
  Type2["LINK"] = "LINK";
  Type2["ACTION"] = "ACTION";
})(Type || (Type = {}));
var Target;
(function(Target2) {
  Target2["SELF"] = "SELF";
  Target2["BLANK"] = "BLANK";
  Target2["PARENT"] = "PARENT";
  Target2["TOP"] = "TOP";
})(Target || (Target = {}));
var TextAlignment;
(function(TextAlignment2) {
  TextAlignment2["AUTO"] = "AUTO";
  TextAlignment2["LEFT"] = "LEFT";
  TextAlignment2["RIGHT"] = "RIGHT";
  TextAlignment2["CENTER"] = "CENTER";
  TextAlignment2["JUSTIFY"] = "JUSTIFY";
})(TextAlignment || (TextAlignment = {}));
var LineStyle;
(function(LineStyle2) {
  LineStyle2["SINGLE"] = "SINGLE";
  LineStyle2["DOUBLE"] = "DOUBLE";
  LineStyle2["DASHED"] = "DASHED";
  LineStyle2["DOTTED"] = "DOTTED";
})(LineStyle || (LineStyle = {}));
var Width;
(function(Width2) {
  Width2["LARGE"] = "LARGE";
  Width2["MEDIUM"] = "MEDIUM";
  Width2["SMALL"] = "SMALL";
})(Width || (Width = {}));
var Alignment;
(function(Alignment2) {
  Alignment2["CENTER"] = "CENTER";
  Alignment2["LEFT"] = "LEFT";
  Alignment2["RIGHT"] = "RIGHT";
})(Alignment || (Alignment = {}));
var ViewMode;
(function(ViewMode2) {
  ViewMode2["NONE"] = "NONE";
  ViewMode2["FULL"] = "FULL";
  ViewMode2["MINI"] = "MINI";
})(ViewMode || (ViewMode = {}));
var LayoutType;
(function(LayoutType2) {
  LayoutType2["COLLAGE"] = "COLLAGE";
  LayoutType2["MASONRY"] = "MASONRY";
  LayoutType2["GRID"] = "GRID";
  LayoutType2["THUMBNAIL"] = "THUMBNAIL";
  LayoutType2["SLIDER"] = "SLIDER";
  LayoutType2["SLIDESHOW"] = "SLIDESHOW";
  LayoutType2["PANORAMA"] = "PANORAMA";
  LayoutType2["COLUMN"] = "COLUMN";
  LayoutType2["MAGIC"] = "MAGIC";
  LayoutType2["FULLSIZE"] = "FULLSIZE";
})(LayoutType || (LayoutType = {}));
var Orientation;
(function(Orientation2) {
  Orientation2["ROWS"] = "ROWS";
  Orientation2["COLUMNS"] = "COLUMNS";
})(Orientation || (Orientation = {}));
var Crop;
(function(Crop2) {
  Crop2["FILL"] = "FILL";
  Crop2["FIT"] = "FIT";
})(Crop || (Crop = {}));
var ThumbnailsAlignment;
(function(ThumbnailsAlignment2) {
  ThumbnailsAlignment2["TOP"] = "TOP";
  ThumbnailsAlignment2["RIGHT"] = "RIGHT";
  ThumbnailsAlignment2["BOTTOM"] = "BOTTOM";
  ThumbnailsAlignment2["LEFT"] = "LEFT";
  ThumbnailsAlignment2["NONE"] = "NONE";
})(ThumbnailsAlignment || (ThumbnailsAlignment = {}));
var GIFType;
(function(GIFType2) {
  GIFType2["NORMAL"] = "NORMAL";
  GIFType2["STICKER"] = "STICKER";
})(GIFType || (GIFType = {}));
var Source;
(function(Source2) {
  Source2["HTML"] = "HTML";
  Source2["ADSENSE"] = "ADSENSE";
  Source2["AI"] = "AI";
  Source2["AI_WIDGET"] = "AI_WIDGET";
})(Source || (Source = {}));
var Position;
(function(Position2) {
  Position2["START"] = "START";
  Position2["END"] = "END";
  Position2["TOP"] = "TOP";
  Position2["HIDDEN"] = "HIDDEN";
})(Position || (Position = {}));
var MapType;
(function(MapType2) {
  MapType2["ROADMAP"] = "ROADMAP";
  MapType2["SATELITE"] = "SATELITE";
  MapType2["HYBRID"] = "HYBRID";
  MapType2["TERRAIN"] = "TERRAIN";
})(MapType || (MapType = {}));
var ViewRole;
(function(ViewRole2) {
  ViewRole2["CREATOR"] = "CREATOR";
  ViewRole2["VOTERS"] = "VOTERS";
  ViewRole2["EVERYONE"] = "EVERYONE";
})(ViewRole || (ViewRole = {}));
var VoteRole;
(function(VoteRole2) {
  VoteRole2["SITE_MEMBERS"] = "SITE_MEMBERS";
  VoteRole2["ALL"] = "ALL";
})(VoteRole || (VoteRole = {}));
var PollLayoutType;
(function(PollLayoutType2) {
  PollLayoutType2["LIST"] = "LIST";
  PollLayoutType2["GRID"] = "GRID";
})(PollLayoutType || (PollLayoutType = {}));
var PollLayoutDirection;
(function(PollLayoutDirection2) {
  PollLayoutDirection2["LTR"] = "LTR";
  PollLayoutDirection2["RTL"] = "RTL";
})(PollLayoutDirection || (PollLayoutDirection = {}));
var BackgroundType;
(function(BackgroundType2) {
  BackgroundType2["COLOR"] = "COLOR";
  BackgroundType2["IMAGE"] = "IMAGE";
  BackgroundType2["GRADIENT"] = "GRADIENT";
})(BackgroundType || (BackgroundType = {}));
var DecorationType;
(function(DecorationType2) {
  DecorationType2["BOLD"] = "BOLD";
  DecorationType2["ITALIC"] = "ITALIC";
  DecorationType2["UNDERLINE"] = "UNDERLINE";
  DecorationType2["SPOILER"] = "SPOILER";
  DecorationType2["ANCHOR"] = "ANCHOR";
  DecorationType2["MENTION"] = "MENTION";
  DecorationType2["LINK"] = "LINK";
  DecorationType2["COLOR"] = "COLOR";
  DecorationType2["FONT_SIZE"] = "FONT_SIZE";
  DecorationType2["EXTERNAL"] = "EXTERNAL";
  DecorationType2["STRIKETHROUGH"] = "STRIKETHROUGH";
  DecorationType2["SUPERSCRIPT"] = "SUPERSCRIPT";
  DecorationType2["SUBSCRIPT"] = "SUBSCRIPT";
  DecorationType2["FONT_FAMILY"] = "FONT_FAMILY";
})(DecorationType || (DecorationType = {}));
var FontType;
(function(FontType2) {
  FontType2["PX"] = "PX";
  FontType2["EM"] = "EM";
})(FontType || (FontType = {}));
var ImageStylesPosition;
(function(ImageStylesPosition2) {
  ImageStylesPosition2["START"] = "START";
  ImageStylesPosition2["END"] = "END";
  ImageStylesPosition2["TOP"] = "TOP";
})(ImageStylesPosition || (ImageStylesPosition = {}));
var AspectRatio;
(function(AspectRatio2) {
  AspectRatio2["SQUARE"] = "SQUARE";
  AspectRatio2["RECTANGLE"] = "RECTANGLE";
})(AspectRatio || (AspectRatio = {}));
var Resizing;
(function(Resizing2) {
  Resizing2["FILL"] = "FILL";
  Resizing2["FIT"] = "FIT";
})(Resizing || (Resizing = {}));
var Placement;
(function(Placement2) {
  Placement2["IMAGE"] = "IMAGE";
  Placement2["PRODUCT_INFO"] = "PRODUCT_INFO";
})(Placement || (Placement = {}));
var CardStylesType;
(function(CardStylesType2) {
  CardStylesType2["CONTAINED"] = "CONTAINED";
  CardStylesType2["FRAMELESS"] = "FRAMELESS";
})(CardStylesType || (CardStylesType = {}));
var CardStylesAlignment;
(function(CardStylesAlignment2) {
  CardStylesAlignment2["START"] = "START";
  CardStylesAlignment2["CENTER"] = "CENTER";
  CardStylesAlignment2["END"] = "END";
})(CardStylesAlignment || (CardStylesAlignment = {}));
var CardStylesLayout;
(function(CardStylesLayout2) {
  CardStylesLayout2["STACKED"] = "STACKED";
  CardStylesLayout2["SIDE_BY_SIDE"] = "SIDE_BY_SIDE";
})(CardStylesLayout || (CardStylesLayout = {}));
var AppType;
(function(AppType2) {
  AppType2["PRODUCT"] = "PRODUCT";
  AppType2["EVENT"] = "EVENT";
  AppType2["BOOKING"] = "BOOKING";
})(AppType || (AppType = {}));
var InitialExpandedItems;
(function(InitialExpandedItems2) {
  InitialExpandedItems2["FIRST"] = "FIRST";
  InitialExpandedItems2["ALL"] = "ALL";
  InitialExpandedItems2["NONE"] = "NONE";
})(InitialExpandedItems || (InitialExpandedItems = {}));
var Direction;
(function(Direction2) {
  Direction2["LTR"] = "LTR";
  Direction2["RTL"] = "RTL";
})(Direction || (Direction = {}));
var VerticalAlignment;
(function(VerticalAlignment2) {
  VerticalAlignment2["TOP"] = "TOP";
  VerticalAlignment2["MIDDLE"] = "MIDDLE";
  VerticalAlignment2["BOTTOM"] = "BOTTOM";
})(VerticalAlignment || (VerticalAlignment = {}));
var NullValue;
(function(NullValue2) {
  NullValue2["NULL_VALUE"] = "NULL_VALUE";
})(NullValue || (NullValue = {}));
var Scaling;
(function(Scaling2) {
  Scaling2["AUTO"] = "AUTO";
  Scaling2["CONTAIN"] = "CONTAIN";
  Scaling2["COVER"] = "COVER";
})(Scaling || (Scaling = {}));
var ImagePosition;
(function(ImagePosition2) {
  ImagePosition2["CENTER"] = "CENTER";
  ImagePosition2["CENTER_LEFT"] = "CENTER_LEFT";
  ImagePosition2["CENTER_RIGHT"] = "CENTER_RIGHT";
  ImagePosition2["TOP"] = "TOP";
  ImagePosition2["TOP_LEFT"] = "TOP_LEFT";
  ImagePosition2["TOP_RIGHT"] = "TOP_RIGHT";
  ImagePosition2["BOTTOM"] = "BOTTOM";
  ImagePosition2["BOTTOM_LEFT"] = "BOTTOM_LEFT";
  ImagePosition2["BOTTOM_RIGHT"] = "BOTTOM_RIGHT";
})(ImagePosition || (ImagePosition = {}));
var Origin;
(function(Origin2) {
  Origin2["IMAGE"] = "IMAGE";
  Origin2["LAYOUT"] = "LAYOUT";
})(Origin || (Origin = {}));
var LayoutDataBackgroundType;
(function(LayoutDataBackgroundType2) {
  LayoutDataBackgroundType2["COLOR"] = "COLOR";
  LayoutDataBackgroundType2["GRADIENT"] = "GRADIENT";
})(LayoutDataBackgroundType || (LayoutDataBackgroundType = {}));
var BackdropType;
(function(BackdropType2) {
  BackdropType2["COLOR"] = "COLOR";
  BackdropType2["GRADIENT"] = "GRADIENT";
})(BackdropType || (BackdropType = {}));
var VerticalAlignmentAlignment;
(function(VerticalAlignmentAlignment2) {
  VerticalAlignmentAlignment2["TOP"] = "TOP";
  VerticalAlignmentAlignment2["MIDDLE"] = "MIDDLE";
  VerticalAlignmentAlignment2["BOTTOM"] = "BOTTOM";
})(VerticalAlignmentAlignment || (VerticalAlignmentAlignment = {}));
var ResponsivenessBehaviour;
(function(ResponsivenessBehaviour2) {
  ResponsivenessBehaviour2["STACK"] = "STACK";
  ResponsivenessBehaviour2["WRAP"] = "WRAP";
})(ResponsivenessBehaviour || (ResponsivenessBehaviour = {}));
var DesignTarget;
(function(DesignTarget2) {
  DesignTarget2["LAYOUT"] = "LAYOUT";
  DesignTarget2["CELL"] = "CELL";
})(DesignTarget || (DesignTarget = {}));
var ImageScalingScaling;
(function(ImageScalingScaling2) {
  ImageScalingScaling2["AUTO"] = "AUTO";
  ImageScalingScaling2["CONTAIN"] = "CONTAIN";
  ImageScalingScaling2["COVER"] = "COVER";
})(ImageScalingScaling || (ImageScalingScaling = {}));
var ImagePositionPosition;
(function(ImagePositionPosition2) {
  ImagePositionPosition2["CENTER"] = "CENTER";
  ImagePositionPosition2["CENTER_LEFT"] = "CENTER_LEFT";
  ImagePositionPosition2["CENTER_RIGHT"] = "CENTER_RIGHT";
  ImagePositionPosition2["TOP"] = "TOP";
  ImagePositionPosition2["TOP_LEFT"] = "TOP_LEFT";
  ImagePositionPosition2["TOP_RIGHT"] = "TOP_RIGHT";
  ImagePositionPosition2["BOTTOM"] = "BOTTOM";
  ImagePositionPosition2["BOTTOM_LEFT"] = "BOTTOM_LEFT";
  ImagePositionPosition2["BOTTOM_RIGHT"] = "BOTTOM_RIGHT";
})(ImagePositionPosition || (ImagePositionPosition = {}));
var CardDataBackgroundType;
(function(CardDataBackgroundType2) {
  CardDataBackgroundType2["COLOR"] = "COLOR";
  CardDataBackgroundType2["GRADIENT"] = "GRADIENT";
})(CardDataBackgroundType || (CardDataBackgroundType = {}));
var ListStyle;
(function(ListStyle2) {
  ListStyle2["PLAIN"] = "PLAIN";
  ListStyle2["NUMBERED"] = "NUMBERED";
  ListStyle2["LETTERS"] = "LETTERS";
  ListStyle2["ROMAN"] = "ROMAN";
  ListStyle2["BULLETED"] = "BULLETED";
  ListStyle2["ALPHABETICAL_INDEX"] = "ALPHABETICAL_INDEX";
  ListStyle2["ALPHABETICAL_INDEX_COMPACT"] = "ALPHABETICAL_INDEX_COMPACT";
})(ListStyle || (ListStyle = {}));
var Indentation;
(function(Indentation2) {
  Indentation2["NESTED"] = "NESTED";
  Indentation2["FLAT"] = "FLAT";
})(Indentation || (Indentation = {}));
var Name;
(function(Name2) {
  Name2["UNKNOWN_NAME"] = "UNKNOWN_NAME";
  Name2["IMAGE_GENERATION"] = "IMAGE_GENERATION";
  Name2["IMAGE_SEARCH"] = "IMAGE_SEARCH";
  Name2["WEB_SEARCH"] = "WEB_SEARCH";
  Name2["READ_WIX_BLOG_POST"] = "READ_WIX_BLOG_POST";
  Name2["READ_WIX_BOOKING_SERVICE"] = "READ_WIX_BOOKING_SERVICE";
  Name2["READ_WIX_EVENT"] = "READ_WIX_EVENT";
  Name2["READ_WIX_STORES_PRODUCT"] = "READ_WIX_STORES_PRODUCT";
  Name2["ANALYZE_RESOURCE"] = "ANALYZE_RESOURCE";
  Name2["TEMPLATE_SEARCH"] = "TEMPLATE_SEARCH";
  Name2["WEB_SCRAPE"] = "WEB_SCRAPE";
  Name2["GENERATE_THEME"] = "GENERATE_THEME";
})(Name || (Name = {}));
var ColorSwatchType;
(function(ColorSwatchType2) {
  ColorSwatchType2["UNKNOWN_COLOR_SWATCH_TYPE"] = "UNKNOWN_COLOR_SWATCH_TYPE";
  ColorSwatchType2["COLOR"] = "COLOR";
  ColorSwatchType2["GRADIENT"] = "GRADIENT";
})(ColorSwatchType || (ColorSwatchType = {}));
var GradientType;
(function(GradientType2) {
  GradientType2["UNKNOWN_GRADIENT_TYPE"] = "UNKNOWN_GRADIENT_TYPE";
  GradientType2["LINEAR"] = "LINEAR";
  GradientType2["RADIAL"] = "RADIAL";
})(GradientType || (GradientType = {}));
var ImageScaling;
(function(ImageScaling2) {
  ImageScaling2["UNKNOWN_IMAGE_SCALING"] = "UNKNOWN_IMAGE_SCALING";
  ImageScaling2["COVER"] = "COVER";
  ImageScaling2["CONTAIN"] = "CONTAIN";
  ImageScaling2["AUTO"] = "AUTO";
})(ImageScaling || (ImageScaling = {}));
var ImageOptionsImagePosition;
(function(ImageOptionsImagePosition2) {
  ImageOptionsImagePosition2["UNKNOWN_IMAGE_POSITION"] = "UNKNOWN_IMAGE_POSITION";
  ImageOptionsImagePosition2["TOP"] = "TOP";
  ImageOptionsImagePosition2["TOP_LEFT"] = "TOP_LEFT";
  ImageOptionsImagePosition2["TOP_RIGHT"] = "TOP_RIGHT";
  ImageOptionsImagePosition2["CENTER"] = "CENTER";
  ImageOptionsImagePosition2["CENTER_LEFT"] = "CENTER_LEFT";
  ImageOptionsImagePosition2["CENTER_RIGHT"] = "CENTER_RIGHT";
  ImageOptionsImagePosition2["BOTTOM"] = "BOTTOM";
  ImageOptionsImagePosition2["BOTTOM_LEFT"] = "BOTTOM_LEFT";
  ImageOptionsImagePosition2["BOTTOM_RIGHT"] = "BOTTOM_RIGHT";
})(ImageOptionsImagePosition || (ImageOptionsImagePosition = {}));
var BackgroundBackgroundType;
(function(BackgroundBackgroundType2) {
  BackgroundBackgroundType2["UNKNOWN_BACKGROUND_TYPE"] = "UNKNOWN_BACKGROUND_TYPE";
  BackgroundBackgroundType2["COLOR"] = "COLOR";
  BackgroundBackgroundType2["IMAGE"] = "IMAGE";
})(BackgroundBackgroundType || (BackgroundBackgroundType = {}));
var ButtonSize;
(function(ButtonSize2) {
  ButtonSize2["UNKNOWN_BUTTON_SIZE"] = "UNKNOWN_BUTTON_SIZE";
  ButtonSize2["SMALL"] = "SMALL";
  ButtonSize2["MEDIUM"] = "MEDIUM";
  ButtonSize2["LARGE"] = "LARGE";
})(ButtonSize || (ButtonSize = {}));
var HorizontalPaddingType;
(function(HorizontalPaddingType2) {
  HorizontalPaddingType2["UNKNOWN_HORIZONTAL_PADDING"] = "UNKNOWN_HORIZONTAL_PADDING";
  HorizontalPaddingType2["NONE"] = "NONE";
  HorizontalPaddingType2["SMALL"] = "SMALL";
  HorizontalPaddingType2["MEDIUM"] = "MEDIUM";
  HorizontalPaddingType2["LARGE"] = "LARGE";
})(HorizontalPaddingType || (HorizontalPaddingType = {}));
var VerticalPaddingType;
(function(VerticalPaddingType2) {
  VerticalPaddingType2["UNKNOWN_VERTICAL_PADDING"] = "UNKNOWN_VERTICAL_PADDING";
  VerticalPaddingType2["NONE"] = "NONE";
  VerticalPaddingType2["SMALL"] = "SMALL";
  VerticalPaddingType2["MEDIUM"] = "MEDIUM";
  VerticalPaddingType2["LARGE"] = "LARGE";
})(VerticalPaddingType || (VerticalPaddingType = {}));
var FormatType;
(function(FormatType2) {
  FormatType2["FLUID"] = "FLUID";
  FormatType2["A4"] = "A4";
  FormatType2["LETTER"] = "LETTER";
  FormatType2["LEGAL"] = "LEGAL";
  FormatType2["SQUARE"] = "SQUARE";
})(FormatType || (FormatType = {}));
var ChunkType;
(function(ChunkType2) {
  ChunkType2["CHUNK_TYPE_UNKNOWN"] = "CHUNK_TYPE_UNKNOWN";
  ChunkType2["EXPLAIN"] = "EXPLAIN";
  ChunkType2["INSERT"] = "INSERT";
  ChunkType2["REPLACE"] = "REPLACE";
  ChunkType2["NODE"] = "NODE";
  ChunkType2["NODE_TEXT"] = "NODE_TEXT";
  ChunkType2["INSERT_END"] = "INSERT_END";
  ChunkType2["REPLACE_END"] = "REPLACE_END";
  ChunkType2["TOOL_USE"] = "TOOL_USE";
  ChunkType2["DEBUG"] = "DEBUG";
  ChunkType2["METADATA"] = "METADATA";
  ChunkType2["PATCH"] = "PATCH";
  ChunkType2["PROGRESS"] = "PROGRESS";
  ChunkType2["SUMMARY"] = "SUMMARY";
  ChunkType2["SUGGESTION"] = "SUGGESTION";
  ChunkType2["THEME"] = "THEME";
  ChunkType2["UPDATE_DOCUMENT"] = "UPDATE_DOCUMENT";
  ChunkType2["UPDATE_DOCUMENT_END"] = "UPDATE_DOCUMENT_END";
  ChunkType2["ERROR"] = "ERROR";
})(ChunkType || (ChunkType = {}));
var SuggestionAction;
(function(SuggestionAction2) {
  SuggestionAction2["SUGGESTION_ACTION_UNKNOWN"] = "SUGGESTION_ACTION_UNKNOWN";
  SuggestionAction2["REPLACE"] = "REPLACE";
  SuggestionAction2["INSERT"] = "INSERT";
})(SuggestionAction || (SuggestionAction = {}));
var Action;
(function(Action2) {
  Action2["UNKNOWN_ACTION"] = "UNKNOWN_ACTION";
  Action2["INSERT"] = "INSERT";
  Action2["REPLACE"] = "REPLACE";
})(Action || (Action = {}));
var PositionsPosition;
(function(PositionsPosition2) {
  PositionsPosition2["UNKNOWN_POSITION"] = "UNKNOWN_POSITION";
  PositionsPosition2["RANGE"] = "RANGE";
})(PositionsPosition || (PositionsPosition = {}));
var OutputMode;
(function(OutputMode2) {
  OutputMode2["HTML"] = "HTML";
  OutputMode2["WIDGET"] = "WIDGET";
})(OutputMode || (OutputMode = {}));
var WebhookIdentityType;
(function(WebhookIdentityType2) {
  WebhookIdentityType2["UNKNOWN"] = "UNKNOWN";
  WebhookIdentityType2["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
  WebhookIdentityType2["MEMBER"] = "MEMBER";
  WebhookIdentityType2["WIX_USER"] = "WIX_USER";
  WebhookIdentityType2["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));

// ../one-ricos/dist/es/theme-utils/gradient-to-background-image.js
init_color_utils2();
var gradientToBackgroundImage = (gradient) => {
  if (gradient?.type === GradientType.LINEAR) {
    return `linear-gradient(${gradient.linearOptions}deg, ${[...gradient.stops ?? []].sort((a, b) => (a.position ?? 0) - (b.position ?? 0)).map(
      (stop) => `${hexToRgba(stop.color ?? void 0, (stop.opacity ?? 1) * 100)} ${((stop.position ?? 0) * 100).toFixed(2)}%`
    ).join(", ")})`;
  }
  if (gradient?.type === GradientType.RADIAL) {
    return `radial-gradient(circle at ${gradient.radialOptions?.x}% ${gradient.radialOptions?.y}%, ${[...gradient.stops ?? []].sort((a, b) => (a.position ?? 0) - (b.position ?? 0)).map(
      (stop) => `${hexToRgba(stop.color ?? void 0, (stop.opacity ?? 1) * 100)} ${((stop.position ?? 0) * 100).toFixed(2)}%`
    ).join(", ")})`;
  }
  return "";
};

// ../one-ricos/dist/es/_shared/resolve-page-design-overlay.js
function resolvePageDesignOverlay(color, imageOpacity, opacityMax) {
  return imageOpacity >= opacityMax ? color : resolveBackwardCompatOverlay(color, imageOpacity, opacityMax);
}

// ../one-ricos/dist/es/theme-utils/calculate-clamp.js
var roundValue = (n) => Math.round((n + Number.EPSILON) * 1e4) / 1e4;
var MIN_FONT_SIZE_RATIO = 0.65;
var CLAMP_MIN_WIDTH = 320;
var CLAMP_MAX_WIDTH = 900;
var calculateClamp = ({
  maxSize,
  minSize,
  minWidth = CLAMP_MIN_WIDTH,
  maxWidth = CLAMP_MAX_WIDTH,
  relativeTo = "viewport"
}) => {
  const isNegative = minSize > maxSize;
  const min = isNegative ? maxSize : minSize;
  const max = isNegative ? minSize : maxSize;
  const unit = "px";
  const relativeUnits = {
    viewport: "vw",
    container: "cqw"
  };
  const relativeUnit = relativeUnits[relativeTo] || relativeUnits.viewport;
  const slope = (maxSize - minSize) / (maxWidth - minWidth);
  const intersection = -1 * minWidth * slope + minSize;
  return `clamp(${roundValue(min)}${unit}, ${roundValue(intersection)}${unit} + ${roundValue(slope * 100)}${relativeUnit}, ${roundValue(max)}${unit})`;
};

// ../one-ricos/dist/es/theme-utils/design-to-ricos-theme.js
init_color_utils2();
var toNumber = (value) => {
  if (value === void 0 || value === null) {
    return void 0;
  }
  const parsed = typeof value === "string" ? parseFloat(value) : value;
  return isNaN(parsed) ? void 0 : parsed;
};
var designColorPaletteToRicosPalette = (colorPalette) => {
  if (!colorPalette) {
    return void 0;
  }
  const bgColor = colorPalette[0];
  const textColor = colorPalette[4];
  const [calcShade1, calcShade2, calcShade3] = bgColor && textColor ? calculateShades(bgColor, textColor) : [];
  return {
    format: "color",
    bgColor,
    accent1: colorPalette[1],
    accent2: colorPalette[2],
    accent3: colorPalette[3],
    textColor,
    accent4: colorPalette[5],
    shade1: colorPalette[6] ?? calcShade1,
    shade2: colorPalette[7] ?? calcShade2,
    shade3: colorPalette[8] ?? calcShade3
  };
};
var designToRicosTheme = (design, getHorizontalPaddingForBreakout, fluidFontSizeStrategy, isPagesEnabled) => {
  const typography = design?.typography;
  const image = design?.image;
  fluidFontSizeStrategy = fluidFontSizeStrategy ?? "none";
  const fontToRicosFont = (key) => {
    const size = toNumber(typography?.[key]?.size);
    const paragraphSize = toNumber(typography?.paragraph?.size);
    const weight = toNumber(typography?.[key]?.weight);
    const lineHeight = toNumber(typography?.[key]?.lineHeight);
    const letterSpacing = toNumber(typography?.[key]?.letterSpacing);
    const responsiveFontSize = fluidFontSizeStrategy !== "none" && size ? calculateClamp({
      maxSize: size,
      minSize: Math.max(paragraphSize ?? 0, size * MIN_FONT_SIZE_RATIO),
      relativeTo: fluidFontSizeStrategy === "vw" ? "viewport" : "container"
    }) : void 0;
    return {
      fontFamily: typography?.[key]?.fontFamily ?? void 0,
      fontWeight: weight !== void 0 ? `${weight}` : void 0,
      color: typography?.[key]?.color ?? void 0,
      fontSize: fluidFontSizeStrategy === "none" ? size ? `${size}px` : void 0 : responsiveFontSize,
      lineHeight: lineHeight ?? void 0,
      letterSpacing: letterSpacing !== void 0 ? `${letterSpacing}em` : void 0
    };
  };
  const getDefaultHorizontalPaddingForBreakout = (contentWidth) => {
    switch (contentWidth) {
      case HorizontalPaddingType.SMALL:
        return "128px";
      case HorizontalPaddingType.MEDIUM:
        return "80px";
      case HorizontalPaddingType.LARGE:
        return "40px";
      default:
        return "80px";
    }
  };
  const horizontalPadding = (getHorizontalPaddingForBreakout ?? getDefaultHorizontalPaddingForBreakout)(design?.pageSetup?.horizontalPadding);
  const getVerticalPaddingValue = (padding, side) => {
    switch (padding) {
      case VerticalPaddingType.NONE:
        return side === "end" ? "16px" : "0px";
      case VerticalPaddingType.SMALL:
        return side === "end" ? "16px" : "10px";
      case VerticalPaddingType.MEDIUM:
        return "26px";
      case VerticalPaddingType.LARGE:
        return "52px";
      default:
        return side === "end" ? "16px" : "0px";
    }
  };
  const verticalPaddingStart = getVerticalPaddingValue(design?.pageSetup?.verticalPadding, "start");
  const verticalPaddingEnd = getVerticalPaddingValue(design?.pageSetup?.verticalPadding, "end");
  const getCardStyle = () => {
    const commonProps = {
      selectionBorderColor: "var(--bounding-box-color, rgba(0, 102, 255, 0.4))",
      selectionBorderWidth: "calc(var(--reverse-zoom-ratio) * 2px)",
      selectionActiveColor: "var(--selection-color, #2F5DFF)",
      paddingBlockStart: verticalPaddingStart,
      paddingBlockEnd: verticalPaddingEnd
    };
    if (design?.background?.type === BackgroundBackgroundType.IMAGE) {
      const imageOptions = design.background?.imageOptions;
      const overlayColorType = imageOptions?.color?.type;
      let backgroundImageOverlay;
      if (overlayColorType === ColorSwatchType.COLOR && imageOptions?.color?.colorOptions) {
        const resolved = resolvePageDesignOverlay(
          imageOptions.color.colorOptions,
          imageOptions.opacity ?? 1,
          1
        );
        backgroundImageOverlay = hexToRgba(resolved);
      } else if (overlayColorType === ColorSwatchType.GRADIENT) {
        backgroundImageOverlay = gradientToBackgroundImage(imageOptions?.color?.gradientOptions);
      }
      return {
        ...commonProps,
        backgroundImage: imageOptions?.url ? `url(${imageOptions.url})` : void 0,
        backgroundSize: imageOptions?.scaling?.toLowerCase() || "cover",
        backgroundPosition: imageOptions?.position?.toLowerCase().split("_").join(" ") || "center",
        backgroundImageOverlay
      };
    }
    if (design?.background?.type === BackgroundBackgroundType.COLOR) {
      if (design?.background?.colorOptions?.color?.type === ColorSwatchType.COLOR) {
        return {
          ...commonProps,
          backgroundColor: hexToRgba(
            design.background.colorOptions?.color?.colorOptions ?? void 0
          )
        };
      }
      if (design?.background?.colorOptions?.color?.type === ColorSwatchType.GRADIENT) {
        return {
          ...commonProps,
          backgroundGradient: gradientToBackgroundImage(
            design.background?.colorOptions?.color?.gradientOptions
          )
        };
      }
    }
    return {
      ...commonProps,
      backgroundColor: design?.colorPalette?.[0]
    };
  };
  return {
    colorPalette: designColorPaletteToRicosPalette(design?.colorPalette),
    typography: {
      fontFamily: typography?.paragraph?.fontFamily ?? void 0
    },
    customStyles: {
      h1: fontToRicosFont("heading1"),
      h2: fontToRicosFont("heading2"),
      h3: fontToRicosFont("heading3"),
      h4: fontToRicosFont("heading4"),
      h5: fontToRicosFont("heading5"),
      h6: fontToRicosFont("heading6"),
      p: fontToRicosFont("paragraph"),
      quote: {
        borderColor: design?.colorPalette?.[1]
      },
      link: {
        color: design?.colorPalette?.[1]
      },
      hashtag: {
        color: design?.colorPalette?.[1]
      },
      button: {
        color: design?.button?.textColor ?? void 0,
        backgroundColor: hexToRgba(design?.button?.backgroundColor ?? void 0),
        buttonSize: design?.button?.size === ButtonSize.SMALL ? "small" : design?.button?.size === ButtonSize.LARGE ? "large" : design?.button?.size === ButtonSize.MEDIUM ? "medium" : void 0,
        borderRadius: design?.button?.border?.radius ? `${design?.button?.border?.radius}px` : void 0,
        borderWidth: design?.button?.border?.width ? `${design?.button?.border?.width}px` : void 0,
        borderColor: hexToRgba(design?.button?.border?.color ?? void 0),
        colorHover: design?.button?.hover?.textColor ?? void 0,
        backgroundColorHover: hexToRgba(design?.button?.hover?.backgroundColor ?? void 0),
        borderColorHover: hexToRgba(design?.button?.hover?.borderColor ?? void 0)
      },
      codeBlock: {
        color: design?.colorPalette?.[4],
        backgroundColor: design?.colorPalette?.[2]
      },
      table: {
        backgroundColor: design?.colorPalette?.[0],
        borderColor: design?.colorPalette?.[2]
      },
      audio: {
        titleColor: design?.colorPalette?.[4],
        subtitleColor: design?.colorPalette?.[3],
        backgroundColor: design?.colorPalette?.[0],
        borderColor: design?.colorPalette?.[2],
        actionColor: design?.colorPalette?.[1],
        actionTextColor: design?.colorPalette?.[0]
      },
      file: {
        color: design?.colorPalette?.[4],
        backgroundColor: design?.colorPalette?.[0],
        borderColor: design?.colorPalette?.[2],
        iconColor: design?.colorPalette?.[1],
        iconStrokeColor: design?.colorPalette?.[2]
      },
      verticalEmbed: {
        color: design?.colorPalette?.[4],
        backgroundColor: design?.colorPalette?.[0],
        borderColor: design?.colorPalette?.[2]
      },
      toc: {
        color: design?.colorPalette?.[1],
        titleColor: design?.colorPalette?.[4],
        borderColor: design?.colorPalette?.[2]
      },
      mention: { color: design?.colorPalette?.[1], backgroundColor: "none" },
      ...isPagesEnabled ? { card: getCardStyle() } : {},
      image: {
        borderColor: hexToRgba(design?.image?.border?.color ?? void 0),
        borderWidth: image?.border?.width ? `${image?.border?.width}px` : void 0,
        borderRadius: image?.border?.radius ? `${image?.border?.radius}px` : void 0
      },
      editor: {
        maxHeight: "100%",
        addPluginButton: {
          positionInlineStart: "4px"
        }
      },
      container: isPagesEnabled ? {} : {
        paddingBlockStart: verticalPaddingStart,
        paddingBlockEnd: verticalPaddingEnd
      },
      footerToolbar: {
        marginTop: "2px",
        paddingInlineStart: "10px",
        paddingInlineEnd: "10px"
      }
    },
    breakout: {
      rule: ({ node }) => {
        if (node.type === "LAYOUT") {
          return "fullWidth";
        }
        if (["IMAGE", "GALLERY", "VIDEO", "GIF", "SHAPE"].includes(node.type) && node) {
          const containerData = node.type === "IMAGE" ? node.imageData?.containerData : node.type === "GALLERY" ? node.galleryData?.containerData : node.type === "VIDEO" ? node.videoData?.containerData : node.type === "GIF" ? node.gifData?.containerData : node.shapeData?.containerData;
          if (containerData?.width?.size === "FULL_WIDTH") {
            return "fullWidth";
          }
          return "normal";
        }
        return "normal";
      },
      normalPadding: {
        start: horizontalPadding,
        end: horizontalPadding
      },
      fullWidthPadding: {
        start: "0",
        end: "0"
      }
    }
  };
};

// src/components/design-panel/design-to-page-css-properties.ts
var designToPageCssProperties = (design, stageSize) => {
  return {
    "--rt-design-stage-size": stageSize === "mobile" ? "375px" : "1000px",
    ...design?.background?.type === BackgroundBackgroundType.IMAGE ? {
      "--rt-design-background-image": design.background?.imageOptions?.url ? `url(${design.background.imageOptions.url})` : void 0,
      ...design.background?.imageOptions?.color?.type === ColorSwatchType.COLOR ? (() => {
        const colorOptions = design.background?.imageOptions?.color?.colorOptions ?? void 0;
        const resolvedColor = colorOptions ? resolvePageDesignOverlay(
          colorOptions,
          design.background?.imageOptions?.opacity ?? 1,
          1
        ) : colorOptions;
        return {
          "--rt-design-background-image-bg-color": hexToRgba(resolvedColor)
        };
      })() : {},
      ...design.background?.imageOptions?.color?.type === ColorSwatchType.GRADIENT ? {
        "--rt-design-background-image-bg-gradient": gradientToBackgroundImage(
          design.background?.imageOptions?.color?.gradientOptions ?? void 0
        )
      } : {},
      "--rt-design-background-image-scaling": design.background.imageOptions?.scaling?.toLowerCase(),
      "--rt-design-background-image-position": design.background.imageOptions?.position?.toLowerCase().split("_").join(" ")
    } : {
      ...design?.background?.type === BackgroundBackgroundType.COLOR && design?.background?.colorOptions?.color?.type === ColorSwatchType.COLOR ? {
        "--rt-design-background-color": hexToRgba(
          design.background.colorOptions?.color?.colorOptions ?? void 0
        )
      } : {},
      ...design?.background?.type === BackgroundBackgroundType.COLOR && design?.background?.colorOptions?.color?.type === ColorSwatchType.GRADIENT ? {
        "--rt-design-background-gradient": gradientToBackgroundImage(
          design.background?.colorOptions?.color?.gradientOptions
        )
      } : {}
    }
  };
};

// src/utils/font-family.ts
var WIXEL_FONT_FALLBACK = "rubik-v2";
var withFallbackFontFamily = (fontFamily) => fontFamily ? `${fontFamily}, ${WIXEL_FONT_FALLBACK}` : fontFamily;
var withWixelThemeFontFallback = (design) => {
  if (!design.typography) {
    return design;
  }
  return {
    ...design,
    typography: Object.fromEntries(
      Object.entries(design.typography).map(([key, typography]) => [
        key,
        typography ? {
          ...typography,
          fontFamily: withFallbackFontFamily(typography.fontFamily)
        } : typography
      ])
    )
  };
};
export {
  WIXEL_FONT_FALLBACK,
  designToPageCssProperties,
  designToRicosTheme,
  withWixelThemeFontFallback
};
//# sourceMappingURL=exports.js.map
